export const TOTAL_INTRO_STEP = 5;
